export default "__VITE_ASSET__CWhwGe8e__";